import React from "react"
import ForgotPassword from "@/components/ForgotPassword"
import AccountLayout from "@/components/AccountLayout"
import Message from "@/components/Message"

export default function ForgotPasswordView() {
  const gradientBox = <ForgotPassword />
  const message = <Message></Message>

  return <AccountLayout gradientBox={gradientBox} message={message} />
}
